import React, {useCallback, useMemo} from 'react';
import {SelectGroup} from '@flixbus/honeycomb-react';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {useAppSelector} from '@/Pages/Common/hooks/useAppSelector';
import {updateFilter} from '../../../store/slice';
import {ProductionCostEntryStatus} from '../../../store/types';
import {CalculationStatusFilterOptions} from './CalculationStatusFilter.constants';

const CalculationStatusFilter: React.FC = () => {
  const statuses = useAppSelector(
    ({calculatedEntries}) => calculatedEntries.filters.statuses
  );
  const dispatch = useAppDispatch();

  const handleSelect = useCallback(
    (value: ProductionCostEntryStatus[]) => {
      dispatch(
        updateFilter({
          field: 'statuses',
          value
        })
      );
    },
    [dispatch]
  );

  const options = useMemo(() => {
    return CalculationStatusFilterOptions.map(option => ({
      ...option,
      onClick: () => {
        const newSelection = statuses.includes(option.value)
          ? statuses.filter(item => item !== option.value)
          : [...statuses, option.value];

        handleSelect(newSelection);
      }
    }));
  }, [handleSelect, statuses]);

  return (
    <SelectGroup
      extraClasses="calculation-select-group"
      label="Calculation status"
      options={options}
      multi
    />
  );
};

export default React.memo(CalculationStatusFilter);
